import { optionsCategory, optionsMedium, optionsOrientation, optionsSize, optionsStyle, optionsSurface } from "./options";
import { getValueInputSelect } from "components/InputSelect/InputSelect";

export function validateForm(key: string, data: any, errors: {[key: string]: string | undefined}, usertype: string): {[key: string]: string | undefined} {
    let dataErrors : {[key: string]: string | undefined} = {...errors};

    if (key === "all" || key === "title") {
        const title = data?.title;
        const eTitle:string | undefined = validateTitle(title);
        if (eTitle !== undefined) {
            dataErrors.title = eTitle;
        } else {
            if ("title" in dataErrors) {
                delete dataErrors.title;
            }
        }
        
    }

    if (key === "all" || key === "description") {
        const description = data?.description;
        const eDescription:string | undefined = validateDescription(description);
        if (eDescription !== undefined) {
            dataErrors.description = eDescription;
        } else {
            if ("description" in dataErrors) {
                delete dataErrors.description;
            }
        }
    }

    if (usertype === "gallery") {
        if (key === "all" || key === "artistName") {
            const artistName = data?.artistName;
            const eArtistName:string | undefined = validateArtistName(artistName);
            if (eArtistName !== undefined) {
                dataErrors.artistName = eArtistName;
            } else {
                if ("artistName" in dataErrors) {
                    delete dataErrors.artistName;
                }
            }
        }
    } else {
        if ("artistName" in dataErrors) {
            delete dataErrors.artistName;
        }
    }

    if (key === "all" || key === "orientation") {
        const orientation = data?.orientation;
        const eOrientation:string | undefined = validateOrientation(orientation);
        if (eOrientation !== undefined) {
            dataErrors.orientation = eOrientation;
        } else {
            if ("orientation" in dataErrors) {
                delete dataErrors.orientation;
            }
        }
    }

    if (key === "all" || key === "year") {
        const year = data?.year;
        const eYear:string | undefined = validateYear(year);
        if (eYear !== undefined) {
            dataErrors.year = eYear;
        } else {
            if ("year" in dataErrors) {
                delete dataErrors.year;
            }
        }
    }
    
    if (key === "all" || key === "category") {
        const category = data?.category;
        const eCategory:string | undefined = validateCategory(category);
        if (eCategory !== undefined) {
            dataErrors.category = eCategory;
        } else {
            if ("category" in dataErrors) {
                delete dataErrors.category;
            }
        }

        if (key === "category" && category !== "category_sculptures") {
            if ("depth" in dataErrors) {
                delete dataErrors.depth;
            }
            if ("weight" in dataErrors) {
                delete dataErrors.weight;
            }
        }
    }

    if (key === "all" || key === "style") {
        const style = data?.style;
        const eStyle:string | undefined = validateStyle(style);
        if (eStyle !== undefined) {
            dataErrors.style = eStyle;
        } else {
            if ("style" in dataErrors) {
                delete dataErrors.style;
            }
        }
    }

    if (key === "all" || key === "surface") {
        const surface = data?.surface;
        const eSurface:string | undefined = validateSurface(surface);
        if (eSurface !== undefined) {
            dataErrors.surface = eSurface;
        } else {
            if ("surface" in dataErrors) {
                delete dataErrors.surface;
            }
        }
    }

    if (key === "all" || key === "medium") {
        const medium = data?.medium;
        const eMedium:string | undefined = validateMedium(medium);
        if (eMedium !== undefined) {
            dataErrors.medium = eMedium;
        } else {
            if ("medium" in dataErrors) {
                delete dataErrors.medium;
            }
        }
    }
    
    if (key === "all" || key === "size") {
        const size = data?.size;
        const eSize:string | undefined = validateSize(size);
        if (eSize !== undefined) {
            dataErrors.size = eSize;
        } else {
            if ("size" in dataErrors) {
                delete dataErrors.size;
            }
        }
    }
    
    if (key === "all" || key === "width") {
        const width = data?.width;
        const eWidth:string | undefined = validateWidth(width);
        if (eWidth !== undefined) {
            dataErrors.width = eWidth;
        } else {
            if ("width" in dataErrors) {
                delete dataErrors.width;
            }
        }
    }

    if (key === "all" || key === "height") {
        const height = data?.height;
        const eHeight:string | undefined = validateHeight(height);
        if (eHeight !== undefined) {
            dataErrors.height = eHeight;
        } else {
            if ("height" in dataErrors) {
                delete dataErrors.height;
            }
        }
    }

    if (key === "all" || key === "depth") {
        const depth = data?.depth;
        const eDepth:string | undefined = validateDepth(depth, data?.category);
        if (eDepth !== undefined) {
            dataErrors.depth = eDepth;
        } else {
            if ("depth" in dataErrors) {
                delete dataErrors.depth;
            }
        }
    }

    if (key === "all" || key === "weight") {
        const weight = data?.weight;
        const eWeight:string | undefined = validateWeight(weight, data?.category);
        if (eWeight !== undefined) {
            dataErrors.weight = eWeight;
        } else {
            if ("weight" in dataErrors) {
                delete dataErrors.weight;
            }
        }
    }
    
    if (key === "all" || key === "price") {
        const price = data?.price;
        const ePrice:string | undefined = validatePrice(price);
        if (ePrice !== undefined) {
            dataErrors.price = ePrice;
        } else {
            if ("price" in dataErrors) {
                delete dataErrors.price;
            }
        }
    }

    if (key === "all" || key === "isAgree") {
        const isAgree = data?.isAgree;
        const eIsAgree:string | undefined = validateIsAgree(isAgree);
        if (eIsAgree !== undefined) {
            dataErrors.isAgree = eIsAgree;
        } else {
            if ("isAgree" in dataErrors) {
                delete dataErrors.isAgree;
            }
        }
    }

    return dataErrors;
}

function validateTitle(value: string | undefined | null): string | undefined {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return undefined;
}

function validateDescription(value: string | undefined | null): string | undefined{
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return undefined;
}

function validateArtistName(value: string | undefined | null): string | undefined {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return undefined;
}

function validateOrientation(value: string | undefined | null): string | undefined {
    if (getValueInputSelect(value ?? "", optionsOrientation) === "") {
        return "Fill field";
    }
    return undefined;
}

function validateYear(value: string | undefined | null): string | undefined {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    const numYear = Number(value);

    if (!Number.isInteger(numYear)) {
        return "Must fill is number";
    }

    const nowYear = new Date().getFullYear();

    if (numYear <= 1000 || numYear > nowYear) {
        return "Invalid year";
    }

    return undefined;
}

function validateCategory(value: string | undefined | null): string | undefined {
    if (getValueInputSelect(value ?? "", optionsCategory) === "") {
        return "Fill field";
    }
    return undefined;
}

function validateStyle(value: string | undefined | null): string | undefined {
    if (getValueInputSelect(value ?? "", optionsStyle) === "") {
        return "Fill field";
    }
    return undefined;
}

function validateSurface(value: string | undefined | null): string | undefined {
    if (getValueInputSelect(value ?? "", optionsSurface) === "") {
        return "Fill field";
    }
    return undefined;
}

function validateMedium(value: string | undefined | null): string | undefined {
    if (getValueInputSelect(value ?? "", optionsMedium) === "") {
        return "Fill field";
    }
    return undefined;
}

function validateSize(value: string | undefined | null): string | undefined {
    if (getValueInputSelect(value ?? "", optionsSize) === "") {
        return "Fill field";
    }
    return undefined;
}

function validateWidth(value: string | undefined | null): string | undefined {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    const numWidth = Number(value);

    if (Number.isNaN(numWidth)) {
        return "Must fill is number";
    }

    return undefined;
}

function validateHeight(value: string | undefined | null): string | undefined {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    const numHeight = Number(value);

    if (Number.isNaN(numHeight)) {
        return "Must fill is number";
    }

    return undefined;
}

function validateDepth(value: string | undefined | null, category: string | undefined | null ): string | undefined {
    if (category === "category_sculptures") {
        if (!value || value.length < 1) {
            return "Fill field";
        }
        const numDepth = Number(value);
    
        if (Number.isNaN(numDepth)) {
            return "Must fill is number";
        }
    }

    return undefined;
}

function validateWeight(value: string | undefined | null, category: string | undefined | null ): string | undefined {
    if (category === "category_sculptures") {
        if (!value || value.length < 1) {
            return "Fill field";
        }
        const numWeight = Number(value);
    
        if (Number.isNaN(numWeight)) {
            return "Must fill is number";
        }
    }

    return undefined;
}

function validatePrice(value: string | undefined | null): string | undefined {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    const numPrice = Number(value);

    if (Number.isNaN(numPrice)) {
        return "Must fill is number";
    }

    if (!(numPrice > 0)) {
        return "Invalid price";
    }
    return undefined;
}

function validateIsAgree(value: any): string | undefined {
    if (value !== true) {
        return "Must agree conditional.";
    }
    return undefined;
}